var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"704922b23866c78afcd7966495eeef7ebcb36eef"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["s3nd@s3nd"]={id:"704922b23866c78afcd7966495eeef7ebcb36eef"};
      